var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckoutProviders } from './Providers';
import { CheckoutBaseCss, CheckoutPageWrapper } from './UI';
import { OrderSummary } from './OrderSummary';
import { Payment } from './Payment';
export * from './UI';
export * from './Providers';
export * from './Payment';
export * from './OrderSummary';
export var Checkout = function (_a) {
    var hideHeader = _a.hideHeader, props = __rest(_a, ["hideHeader"]);
    return (_jsx(CheckoutProviders, __assign({}, props, { children: _jsx(CheckoutBaseCss, __assign({}, props, { children: _jsxs(CheckoutPageWrapper, { children: [_jsx(OrderSummary, { hideHeader: hideHeader }), _jsx(Payment, {})] }) })) })));
};
//# sourceMappingURL=index.js.map